<template>

    <button class="btn" :type="btnType" :class="classes">
        <slot></slot>
    </button>

</template>

<style scoped lang="scss">

    .btn {
        @include font-semibold(14px);
        align-items: center;
        appearance: none;
        border: none;
        box-shadow: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        outline: none;
        overflow: hidden;
        position: relative;
        text-decoration: none;
        transition: all .3s;
        text-align: center;
        text-decoration: none;
        user-select: none;
        &:disabled {
            opacity: 1;
        }
        &.btn-block {
            display: block;
            width: 100%;
        }
    }

    .btn {
        &.btn-sm {
            border-radius: 3px;
            font-size: 11px;
            height: 40px;
            padding: 0 15px;
            &.btn-rounded {
                border-radius: 20px;
            }
        }
        &.btn-md {
            border-radius: 5px;
            font-size: 14px;
            height: 50px;
            padding: 0 30px;
            &.btn-rounded {
                border-radius: 25px;
            }
        }
        &.btn-lg {
            border-radius: 5px;
            font-size: 16px;
            height: 60px;
            padding: 0 30px;
            &.btn-rounded {
                border-radius: 30px;
            }
        }
    }

    .btn {
        &.btn-primary {
            background-color: $color-primary !important;
            color: #fff !important;
            &:focus {
                background-color: $color-primary !important;
                color: #fff !important;
            }
            &:hover, &:active, &.active {
                background-color: $color-primary-hover !important;
                color: #fff !important;
            }
        }
        &.btn-secondary {
            background-color: $color-secondary !important;
            color: $color-text !important;
            &:focus {
                background-color: $color-secondary !important;
                color: $color-text !important;
            }
            &:hover, &:active, &.active {
                background-color: $color-secondary-hover !important;
                color: $color-text !important;
            }
        }
        &.btn-white {
            background-color: #fff !important;
            color: $color-link !important;
            &:focus {
                background-color: #fff !important;
                color: $color-link !important;
            }
            &:hover, &:active, &.active {
                background-color: rgba(255,255,255,0.8) !important;
                color: $color-link !important;
            }
        }
        &.btn-dark {
            background-color: $color-text !important;
            color: #fff !important;
            &:focus {
                background-color: $color-text !important;
                color: #fff !important;
            }
            &:hover, &:active, &.active {
                background-color: $color-text-hover !important;
                color: #fff !important;
            }
        }
        &.btn-success {
            background-color: $color-success !important;
            color: #fff !important;
            &:focus {
                background-color: $color-success !important;
                color: #fff !important;
            }
            &:hover, &:active, &.active {
                background-color: $color-success-hover !important;
                color: #fff !important;
            }
        }
        &.btn-danger {
            background-color: $color-danger !important;
            color: #fff !important;
            &:focus {
                background-color: $color-danger !important;
                color: #fff !important;
            }
            &:hover, &:active, &.active {
                background-color: $color-danger-hover !important;
                color: #fff !important;
            }
        }
        &.btn-google {
            background-color: #fff !important;
            border: 1px solid $color-rule;
            color: $color-text !important;
            &:focus {
                background-color: #fff !important;
                color: $color-text !important;
            }
            &:hover, &:active, &.active {
                background-color: $color-bg !important;
                color: $color-text !important;
            }
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'md',
        },
        btnStyle: {
            type: String,
            default: 'primary',
        },
        btnType: {
            type: String,
            default: 'button',
        },
        btnRounded: {
            type: Boolean,
            default: false,
        },
        btnBlock: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                // Sizes
                'btn-sm': this.size === 'sm',
                'btn-md': this.size === 'md',
                'btn-lg': this.size === 'lg',
                // Styles
                'btn-primary': this.btnStyle === 'primary',
                'btn-secondary': this.btnStyle === 'secondary',
                'btn-white': this.btnStyle === 'white',
                'btn-dark': this.btnStyle === 'dark',
                'btn-danger': this.btnStyle === 'danger',
                'btn-success': this.btnStyle === 'success',
                'btn-google': this.btnStyle === 'google',
                // Utilities
                'btn-rounded': this.btnRounded,
                'btn-block': this.btnBlock,
            };
        },

    },

}

</script>
